import $ from "jquery";

import "jquery-mask-plugin";

import objEstados from "./Estados";
import objCidades from "./Cidades";

$(document).ready(function () {
  let urlAtual = window.location.href;

  if (!urlAtual.includes("obrigado.html")) {
    var maskBehavior = function (val) {
        return val.replace(/\D/g, "").length === 11
          ? "(00) 00000-0000"
          : "(00) 00000-0000";
      },
      options = {
        onKeyPress: function (val, e, field, options) {
          field.mask(maskBehavior.apply({}, arguments), options);
        },
      };

    $("#cad-tel").mask(maskBehavior, options);

    $.each(objEstados, function (uf, nome) {
      $("<li/>", {
        value: uf,
        text: nome.toString(),
      })
        .attr(
          "data-element",
          `option_${nome
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/ /g, "-")
            .toLowerCase()}`
        )
        .appendTo($("#formulario-inscricao .estado .dropdown-menu"));
    });

    $(document).on("click", "#formulario-inscricao .select ul li", function () {
      var sel = $(this).text();
      var value = $(this).attr("value");
      var campo = $(this).parents(".select").find("input").attr("id");
      var seta = $(this).parents(".select").find("button svg").html();
      $(this)
        .parents(".select")
        .find("button")
        .html(
          sel +
            '<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            seta +
            "</svg>"
        );
      $(this).parents(".select").find("input").val(sel);
      $(this).parents(".select").find("button").removeClass("error");
      $(this).parents(".select").find(".msg-error").remove();
      if (campo == "cad-estado") {
        $("#cad-cidade")
          .val("")
          .parents(".select")
          .find("button")
          .html(
            'Cidade <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              seta +
              "</svg>"
          );
        $(document)
          .find(".cidade ul li")
          .each(function () {
            if ($(this).attr("value") == value) {
              $(this).css({ display: "block" });
            } else {
              $(this).css({ display: "none" });
            }
          });
      }
    });

    $.each(objCidades, function (index, obj) {
      $("<li/>", {
        value: obj.uf,
        text: obj.Nome.toString(),
      })
        .attr(
          "data-element",
          `option_${obj.Nome.normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/ /g, "-")
            .toLowerCase()}`
        )
        .appendTo($("#formulario-inscricao .cidade .dropdown-menu"));
    });

    document.querySelector("form").setAttribute("novalidate", true); //Desativando validação padrão do navegador

    $("#cad-nome,#cad-mail,#cad-estado,#cad-cidade").keyup(function () {
      if ($(this).val().length > 0) {
        $(this).removeClass("error").parent("div").find(".msg-error").remove();
      }
    });

    // Dispara os eventos de one trust e salesforce, e limpa os campos
    $("#formulario-inscricao").on("submit", function (e) {
      e.preventDefault();
      if (validacaoForm()) {
        const Button = $("#formulario-inscricao #submitform");
        Button.attr("disabled", "disabled");
        Button.text("");
        Button.addClass("loading");

        const Name = $("#cad-nome").val();
        const Phone = $("#cad-tel").val();
        const Email = $("#cad-mail").val();
        const State = $("#cad-estado").val();
        const City = $("#cad-cidade").val();
        const Notas = calcularMedia();

        sendDataLayer(true);

        const apiUrl = getAPIUrl();

        const payload = {
          RecordTypeName: "Lead Interessado",
          origemLead: "Calculadora Wyden",
          segmentacaoSquad: "API - High School",
          name: Name,
          mobilePhone: removerNaoNumericos(Phone),
          email: Email,
          estado: State,
          cidade: City,
          livre2: Notas["media"].toString(),
          informado: true,
          grupoMarcaInteresse: "Wyden",
        };

        const params = {
          method: "POST",
          mode: "cors",
          body: JSON.stringify(payload),
        };

        fetch(apiUrl, params)
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error("Erro ao enviar dados");
            }
          })
          .then((data) => {
            if (Notas["media"] < 400) {
              $(".box-nota")[0].style.display = "none";
              $(".box-nao-elegivel")[0].style.display = "block";
              $(".calculadora-resultado")[0].style.display = "none";
              $(".calculadora-resultado2")[0].style.display = "block";
              $("#fundo-tablet")[0].style.background = "transparent";
              $("#calculadora .calculadora-container").addClass(
                "nova-imagem-tablet2"
              );

              $("#bg-branco")[0].style.display = "none";
              $("#cor-branca-h2")[0].style.color = "#fff";
              $(".texto-nota-baixa")[0].style.color = "#fff";

              if ($(window).width() < 768) {
                $(".banner-resultado")[0].style.display = "block";
              }
            } else {
              $("#bg-branco")[0].style.display = "none";
              $("#cor-branca-h2")[0].style.color = "#fff";
              $("#MediaText")[0].style.display = "none";
              $(".box-nota")[0].style.display = "none";
              $(".box-porcentagen")[0].style.display = "block";
              $(".calculadora-resultado")[0].style.display = "none";
              $(".calculadora-resultado2")[0].style.display = "block";
            }
            $("#fundo-tablet")[0].style.background = "transparent";
            $(".img-menor")[0].style.display = "none";
            $(".img-maior")[0].style.display = "block";
            $(".img-menor-none")[0].style.display = "none";

            if ($(window).width() < 1068) {
              $("#bg-branco")[0].style.display = "none";
              $(".img-menor")[0].style.display = "none";
              $(".img-menor-none")[0].style.display = "none";
              $(".img-maior")[0].style.display = "none";
              $("#fundo-tablet")[0].style.background = "transparent";
              $(".calculadora-resultado")[0].style.display = "none";
              $(".calculadora-resultado2")[0].style.display = "block";
              $("#calculadora .calculadora-container").addClass(
                "nova-imagem-tablet2"
              );
            }

            if ($(window).width() < 768) {
              // Verificar se o estilo display é block
              $(".img-menor")[0].style.display = "none";
              $(".calculadora-resultado")[0].style.display = "none";
              $(".banner-resultado")[0].style.display = "block";

              $("#fundo-tablet")[0].style.background = "transparent";
              if ($(".box-nota").css("display") === "none") {
                // Rolar a tela para o topo
                $("html, body").animate({ scrollTop: 0 }, "slow");
              }
            }

            console.log(data);
            console.log(payload);
          })
          .catch((error) => {
            console.log(payload);
            console.error("Erro na requisição", error);
          });
      }
    });
  }
});

function removerNaoNumericos(string) {
  return string.replace(/[^0-9]/g, "");
}
function getAPIUrl() {
  const hostname = window.location.hostname;
  let apiUrl =
    "https://4uz5qsv3ftpaka5tja3fwhr53q0pawaq.lambda-url.us-east-1.on.aws/";
  if (hostname === "calculadoraenem.wyden.com.br") {
    apiUrl =
      "https://jhmycguzffnrfvy4de5afr5y340vicai.lambda-url.us-east-1.on.aws/";
  }
  return apiUrl;
}

function validacaoForm() {
  const msgError = '<div class="msg-error">Este campo é obrigatório</div>';
  const nomeError = '<div class="msg-error">Insira um nome válido</div>';
  const telefoneError = '<div class="msg-error">Informe um número válido</div>';
  const emailError = '<div class="msg-error">Informe um e-mail válido</div>';

  $(".error").removeClass("error");
  $(".msg-error").remove();

  const errorMessages = [];

  function showError(element, errorMessage) {
    sendDataLayer(false, errorMessage);
    element.addClass("error").focus().parent("div").append(errorMessage);
    errorMessages.push(errorMessage);
  }

  const validateNotEmpty = (element, errorMessage) => {
    if (!element.val()) {
      showError(element, errorMessage);
      return false;
    }
    return true;
  };

  const validateName = (element, errorMessage) => {
    const regexNome = /[0-9]/;
    const nameParts = element.val().split(" ");

    if (
      nameParts.length < 2 ||
      regexNome.test(element.val()) ||
      nameParts[1].length < 2
    ) {
      showError(element, errorMessage);
      return false;
    }

    return true;
  };

  const validateEmail = (element, errorMessage) => {
    if (!element.val() || !validacaoEmail(element.val())) {
      showError(element, errorMessage);
      return false;
    }
    return true;
  };

  const validatePhone = (element, errorMessage) => {
    if (!element.val() || element.val().length < 15) {
      showError(element, errorMessage);
      return false;
    }
    return true;
  };

  const validateChecked = (element, errorMessage) => {
    if (!element.is(":checked")) {
      showError(element, errorMessage);
      return false;
    }
    return true;
  };

  const nome = $("#cad-nome");
  const tel = $("#cad-tel");
  const email = $("#cad-mail");
  const estado = $("#cad-estado");
  const cidade = $("#cad-cidade");
  const chkAceite = $("#check-aceite");

  validateNotEmpty(nome, msgError) && validateName(nome, nomeError);
  validateNotEmpty(tel, msgError) && validatePhone(tel, telefoneError);
  validateNotEmpty(email, msgError) && validateEmail(email, emailError);
  validateNotEmpty(estado, msgError);
  validateNotEmpty(cidade, msgError);
  validateChecked(chkAceite, msgError);

  return errorMessages.length === 0;
}

function sendDataLayer(success, message) {
  window.dataLayer.push({
    event: "submit_status",
    submit_details: {
      form_name: "form-cata-lead-calculadora-enem", // Nome do formulário
      form_campaign: "calculadora-enem", // Nome da campanha, caso haja
      id: undefined, // Id de identificação do usuário criado, caso haja
      success: success, // Status de sucesso
      code: undefined, // Código do erro, caso haja
      description: message ? message : undefined, // Descrição do erro, caso haja
    },
  });
}

function validacaoEmail(field) {
  var usuario = field.substring(0, field.indexOf("@"));
  var dominio = field.substring(field.indexOf("@") + 1, field.length);

  if (
    usuario.length >= 3 &&
    dominio.length >= 3 &&
    usuario.search("@") == -1 &&
    dominio.search("@") == -1 &&
    usuario.search(" ") == -1 &&
    dominio.search(" ") == -1 &&
    dominio.search(".") != -1 &&
    dominio.indexOf(".") >= 1 &&
    field.substring(field.indexOf(".") + 1).length >= 2 &&
    field.substring(field.indexOf("@") + 1).split(".")[0].length >= 3 &&
    dominio.lastIndexOf(".") < dominio.length - 1
  ) {
    return true;
  } else {
    return false;
  }
}

function calcularMedia() {
  let valor1 = parseFloat($("#valor1").val().replace(",", "")) || 0;
  let valor2 = parseFloat($("#valor2").val().replace(",", "")) || 0;
  let valor3 = parseFloat($("#valor3").val().replace(",", "")) || 0;
  let valor4 = parseFloat($("#valor4").val().replace(",", "")) || 0;
  let valor5 = parseFloat($("#valor5").val().replace(",", "")) || 0;

  let soma = valor1 + valor2 + valor3 + valor4 + valor5;
  let media = soma / 5;

  $(".box-calculadora")[0].style.display = "none";
  $(".calculadora-chamada")[0].style.display = "none";
  $(".box-nota")[0].style.display = "block";
  $(".calculadora-resultado")[0].style.display = "block";
  $("#bg-branco")[0].style.display = "block";
  $(".img-menor")[0].style.display = "none";
  $("#calculadora .calculadora-container").addClass("nova-imagem-tablet");
  $(".img-maior")[0].style.display = "block";

  if ($(window).width() < 1068) {
    // Verificar se o estilo display é block
    $(".img-maior")[0].style.display = "none";
    $("#fundo-tablet")[0].style.background = "#fff";
    $("#bg-branco")[0].style.display = "none";
    $("#calculadora").addClass("remove-bg");
  }
  if ($(window).width() < 768) {
    // Verificar se o estilo display é block
    $("#bg-branco")[0].style.display = "none";
    $("#cor-branca-h2")[0].style.color = "#fff";
    $("#MediaText")[0].style.color = "#fff";
    $(".img-menor")[0].style.display = "none";
    $(".mobile-novo")[0].style.display = "none";
    $("#calculadora .calculadora-container").removeClass("nova-imagem-tablet");
    // $("#calculadora .calculadora-container").addClass("nova-imagem-tablet");
    // $("#calculadora .calculadora-container").addClass("nova-imagem-tablet2");
    $("#calculadora .calculadora-container").addClass("nova-ajust-conteudo");
    $("#fundo-tablet")[0].style.background = "transparent";
  }

  // Limita o resultado a no máximo 4 dígitos, com uma vírgula após o terceiro número
  let resultadoFormatado = media.toFixed(1);
  $("#resultado").text(resultadoFormatado);

  // Lógica para exibir a mensagem correspondente
  let porcentagem = 0;
  let submitNotDiscount = document.getElementById("sem-desconto");
  let submitDiscount = document.getElementById("com-desconto");

  if (media >= 0 && media < 400) {
    submitNotDiscount.setAttribute(
      "data-element",
      "button_garantir-bolsa-sem-desconto"
    );
    // Se não for elegível, você pode ajustar a mensagem aqui se necessário
  } else if (media >= 400 && media <= 500) {
    porcentagem = 5;
    submitDiscount.setAttribute(
      "data-element",
      "button_garantir-bolsa-desconto-" + porcentagem
    );
  } else if (media >= 501 && media <= 700) {
    porcentagem = 10;
    submitDiscount.setAttribute(
      "data-element",
      "button_garantir-bolsa-desconto-" + porcentagem
    );
  } else if (media >= 701 && media <= 849) {
    porcentagem = 15;
    submitDiscount.setAttribute(
      "data-element",
      "button_garantir-bolsa-desconto-" + porcentagem
    );
  } else if (media >= 850) {
    porcentagem = 100;
    submitDiscount.setAttribute(
      "data-element",
      "button_garantir-bolsa-desconto-" + porcentagem
    );
  }
  const porcentagemText =
    porcentagem === 100 ? porcentagem + "%" : "+" + porcentagem + "%";

  // Atualizando o conteúdo HTML com a porcentagem
  document.getElementById("porcentagemText").innerText = porcentagemText;

  const response = {
    media: media,
    notas: valor1 + "," + valor2 + "," + valor3 + "," + valor4 + "," + valor5,
    porcentagem_bolsa: porcentagem
  };

  return response;
}

const botaoDescobrirNota = document.getElementById('calcular-notas');
botaoDescobrirNota.addEventListener('click', function() {
  const nota = calcularMedia();
  const evento = {
    'event': 'calculadora_enem_result',
    'nota': nota
  };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(evento);
});

// Inputmask
import Inputmask from "inputmask";

$(".numericInput").each(function () {
  Inputmask("[99]9.9", {
    placeholder: "0",
    clearMaskOnLostFocus: true,
    numericInput: true,
    rightAlign: false,
  }).mask(this);
});

$(".form-control").on("input", function () {
  if ($(this).val() !== "") {
    $(this).addClass("filled");
  } else {
    $(this).removeClass("filled");
  }
});

$(".form-control").on("focus", function () {
  $(this).addClass("focused");
});

$(".form-control").on("blur", function () {
  $(this).removeClass("focused");
});

function validateFormNotas() {
  const valorErro = '<div class="msg-error">Insira um valor válido</div>';
  const valorErroEmpty = '<div class="msg-error">Campo obrigatório</div>';

  const inputs = [
    $("#valor1"),
    $("#valor2"),
    $("#valor3"),
    $("#valor4"),
    $("#valor5"),
  ];

  let hasErrors = false;

  inputs.forEach((input) => {
    const valor = input.val().replace(",", "").trim();
    const hasError = valor === "" || parseFloat(valor) < 1;

    input.on("focus", function () {
      const msgError = this.nextElementSibling;
      if (msgError && msgError.classList.contains("msg-error")) {
        msgError.remove();
      }
      this.classList.remove("erro-nota");
    });

    input[0].classList.toggle("erro-nota", hasError);

    const msgError = input[0].nextElementSibling;
    if (hasError) {
      if (!msgError || !msgError.classList.contains("msg-error")) {
        input[0].insertAdjacentHTML(
          "afterend",
          valor === "" ? valorErroEmpty : valorErro
        );
      }
      hasErrors = true;
    } else {
      if (msgError && msgError.classList.contains("msg-error")) {
        msgError.remove();
      }
    }
  });

  return !hasErrors;
}

$("#calcular-notas").on("click", function (event) {
  event.preventDefault();

  if (validateFormNotas()) {
    calcularMedia();
    if ($(window).width() < 768) {
      // Verificar se o estilo display é block
      if ($(".box-nota").css("display") === "block") {
        // Rolar a tela para o topo
        $("html, body").animate({ scrollTop: 0 }, "slow");
      }
    }
  }
});
